/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Kit_Examples_TitleInputs */

const en_simple_kit_examples_title = /** @type {(inputs: Simple_Kit_Examples_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Things you can ask for`)
};

const id_simple_kit_examples_title = /** @type {(inputs: Simple_Kit_Examples_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contoh yang bisa Anda minta`)
};

/**
* | output |
* | --- |
* | "Things you can ask for" |
*
* @param {Simple_Kit_Examples_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_kit_examples_title = /** @type {((inputs?: Simple_Kit_Examples_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Kit_Examples_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_kit_examples_title(inputs)
	return en_simple_kit_examples_title(inputs)
});